import { render, staticRenderFns } from "./UserProfil.vue?vue&type=template&id=44b16f70&scoped=true&"
import script from "./UserProfil.vue?vue&type=script&lang=js&"
export * from "./UserProfil.vue?vue&type=script&lang=js&"
import style0 from "./UserProfil.vue?vue&type=style&index=0&id=44b16f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b16f70",
  null
  
)

export default component.exports